import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PanelLayout from "layouts/PanelLayout";
import "styles/teacher.css";
import { TbSmartHome } from "react-icons/tb";

const StudentTestPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const subject = location.state?.subject || { title: "Fan nomi" };

  const [activeMenu, setActiveMenu] = useState(null);
  const [tests, setTests] = useState([
    {
      id: 1,
      type: "Standart",
      title: "Qisqa ko‘paytirish formulalari",
      category: "Standart",
    },
    { id: 2, type: "Logic", title: "Tenglamalar testlari", category: "Logic" },
    {
      id: 3,
      type: "Standart",
      title: "Trigonometriya asoslari",
      category: "Standart",
    },
    { id: 4, type: "Logic", title: "Geometriya testlari", category: "Logic" },
  ]);

  const toggleMenu = (id) => {
    setActiveMenu(activeMenu === id ? null : id);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".menu-icon") &&
        !event.target.closest(".dropdown-menu")
      ) {
        setActiveMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const startTest = (test) => {
    navigate("/student/test/start", { state: { test, subject } });
  };

  return (
    <PanelLayout>
      <div className="subject-page">
        {/* ==== Breadcrumb ==== */}
        <div className="tests-header">
          <div className="breadcrumb">
            <span onClick={() => navigate("/student")}>
              <TbSmartHome
                style={{ fontSize: 20, color: "#01CC0D", cursor: "pointer" }}
              />
            </span>
            <span className="divider">/</span>
            <span style={{ cursor: "pointer" }}>{subject.title}</span>
            <span className="divider">/</span>
            <span className="current">Testlar</span>
          </div>
        </div>

        {/* ==== Tests List ==== */}
        <div className="test-grid">
          {tests.map((t) => (
            <div
              key={t.id}
              className="test-box"
              onClick={() =>
                navigate(`/student/test/info/${t.id}`, {
                  state: { subject, type: t.type },
                })
              }
            >
              <div className="test-top">
                <div className="badge-group">
                  <span className={`badge ${t.category.toLowerCase()}`}>
                    {t.category}
                  </span>
                </div>
              </div>

              <h4>{t.title}</h4>
              <p>
                Lorem ipsum dolor sit amet consectetur. Nibh vel donec ultricies
                elementum.
              </p>
            </div>
          ))}
        </div>
      </div>
    </PanelLayout>
  );
};

export default StudentTestPage;
